import { FormGroup } from 'reactstrap';
import React, { useCallback, useEffect, useMemo } from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioButtonDefaultIcon from '@material-ui/icons/RadioButtonUncheckedOutlined';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import { makeStyles } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import EventLabel from '../../components/EventLabel/EventLabel';
import Asterisk from '../../components/Asterisk/Asterisk';
import { runInAction } from 'mobx';

const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: 0,
    marginRight: 0,
  },
  label: {
    ['&.Mui-disabled']: {
      color: 'inherit !important',
    },
    color: 'inherit',
    fontWeight: 'inherit',
    fontSize: 'inherit',
    fontFamily: 'inherit',
  },
}));

function ConfirmMeeting({ settings, orders, activePersonNo, contentModuleId, validations, checkConditions, checkConditionsOld, updateOrder }) {
  const classes = useStyles();

  const { disableChangeLock, required } = settings;

  const validity = useMemo(() => validations.find(v => v.id === contentModuleId), [validations]);
  const orderExtra = useMemo(() => orders?.[activePersonNo]?.orderExtra?.find((oe: any) => oe.name === 'Matchmaking'), [orders, activePersonNo]);
  const isValid = useMemo(() => (required ? orderExtra : undefined), [required, orderExtra]);
  const isChangeLocked = useMemo(() => orders?.[activePersonNo]?.badgeNo && disableChangeLock === false, [disableChangeLock, orders, activePersonNo]);

  useEffect(() => {
    if (isValid && validity && !validity.valid) {
      runInAction(() => {
        validity.valid = true;
      });
    }
  }, [isValid, validity]);

  const handleChange = useCallback(
    (status: boolean) => {
      const orderCopy = { ...orders[activePersonNo] };

      if (!orders[activePersonNo]?.orderExtra) {
        orderCopy.orderExtra = [];
      }

      const index = orderCopy?.orderExtra?.findIndex((oe: any) => oe.name === 'Matchmaking');

      if (index !== -1) {
        orderCopy.orderExtra[index].value = status ? 'True' : 'False';
      } else {
        orderCopy.orderExtra.push({
          name: 'Matchmaking',
          value: status ? 'True' : 'False',
        });
      }

      updateOrder(orderCopy);

      if (validity) {
        runInAction(() => {
          validity.valid = true;
        });
      }
      checkConditions();
      checkConditionsOld();
    },
    [orders, activePersonNo, validity, checkConditions, checkConditionsOld, updateOrder]
  );

  return (
    <div className="w-full">
      <FormGroup className={'cms-question'}>
        <div className="title-holder">
          <label>
            <EventLabel name="ConfirmMatchmaking" groupName="Cms.ConfirmMeeting" />
            {required && <Asterisk />}
          </label>
        </div>
        <RadioGroup defaultValue={undefined} onChange={({ target }) => handleChange(target.value === 'true')} className={`cms-question checkbox-group`}>
          <FormControlLabel
            className="option"
            classes={classes}
            checked={orderExtra?.value === 'True'}
            disabled={isChangeLocked}
            control={
              <Radio
                classes={{ root: classes.root }}
                disableRipple
                style={{ opacity: isChangeLocked ? 0.3 : 1, paddingLeft: 0 }}
                icon={<RadioButtonDefaultIcon style={{ color: isValid === false ? '#d53443' : undefined }} className="checkbox cms-checkbox" />}
                checkedIcon={<RadioButtonCheckedIcon className="checkbox cms-checkbox" />}
              />
            }
            value={'true'}
            label={<EventLabel name="Yes" groupName="Cms.ConfirmMeeting" />}
          />
          <FormControlLabel
            className="option"
            classes={classes}
            checked={orderExtra?.value === 'False'}
            disabled={isChangeLocked}
            control={
              <Radio
                classes={{ root: classes.root }}
                disableRipple
                style={{ opacity: isChangeLocked ? 0.3 : 1, paddingLeft: 0 }}
                icon={<RadioButtonDefaultIcon style={{ color: isValid === false ? '#d53443' : undefined }} className="checkbox cms-checkbox" />}
                checkedIcon={<RadioButtonCheckedIcon className="checkbox cms-checkbox" />}
              />
            }
            value={'false'}
            label={<EventLabel name="No" groupName="Cms.ConfirmMeeting" />}
          />
        </RadioGroup>
      </FormGroup>
    </div>
  );
}

export default observer(ConfirmMeeting);
